import React from "react";
import PropTypes from "prop-types";

const AddUrlPopup = ({ handleClose }) => {
  return (
    <div className="fixed left-0 top-0 z-50 flex size-full items-start justify-center border-grey-DDDFDE bg-black-00000030">
      <div className="relative mt-17 h-321px w-457px rounded-[10px] bg-white p-6">
        <div className="flex flex-col">
          <div className="font-MontserratSemiBold text-ft22-26.82-0.4 text-black-20">
            AD Unit Code
          </div>
          <div className="mt-21px font-PoppinsRegular text-ft15-22.5-0.2 text-grey-575757">
            An ad unit is a specific space on a web page to place an
            advertisement. Ad units contain the advertising code necessary to
            display ads from the ad server.
          </div>
          <div className="mt-6 font-PoppinsRegular text-ft15-22.5-0.2 text-grey-575757">
            You can get this code through your preference Ad Management Program.
          </div>
          <div className="mt-35px flex justify-center">
            <button
              onClick={handleClose}
              className="h-12 w-183px rounded border border-grey-DBDBDB"
            >
              <span className="font-MontserratSemiBold text-ft15-26.25 ">
                Close
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
AddUrlPopup.propTypes = {
  handleClose: PropTypes
};
export default AddUrlPopup;
